import React, { useState, useEffect } from 'react'
import { Container, Typography, Grid2, Link, Skeleton, Paper, Box, Divider } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { IconChevronRight } from '@tabler/icons-react'
import { Link as RouterLink, useParams, useNavigate } from 'react-router-dom'
import DOMPurify from 'dompurify';  
import axios from 'axios'
import { useQuery } from '@tanstack/react-query'

import CustomButton from '@components/button/customButton'
import CustomAutocomplete from '@components/inputs/customAutocomplete'

import { UserApiEndpoints } from '@configuration/apiEndpoints'

import "./supportUs.css";

const data = {
  postGuid: 'test-1',
  image: 'https://picsum.photos/id/13/1600/2300',
  category: 'meditation',
  titleEng: '108 benevolent protectors',
  titleCNSimp: '竺山禅院108护竺善士',
  titleCNTrad: '竺山禪院108護竺善士',

  
  contentEng: `<p><strong>竺山青少年禅意营</strong></p><p></p><p>马来西亚竺山禅院以弘扬汉传禅法及禅文化为使命，致力于打造一个融教育与实践于一体的禅修中心。这片灵气山地，将为无数身心疲惫的现代人提供安顿之所，更为禅文化的传承与推广奠定基础。</p><p></p><p>禅院预计于2028年内建成，然而初期建设所需经费庞大，必须仰赖社会大众的共同护持方能圆满完成。您的发心捐献，将成为禅院建成的基石，也将为未来禅修学员的身心成长点燃希望的灯。</p><p></p><p>每一份随喜捐助，都是对禅文化发展的巨大支持；每一份善心护持，都是为社会注入平和宁静的力量。您的点滴善意，将汇聚成禅院建设的坚实后盾，让这片土地上的人们得以因禅法受益，改善生命品质。</p><p></p><p><strong>如何护持</strong></p><p></p><p>请填写您愿意护持的金额，无论多少，皆是不可或缺的一份力量。</p><p></p><p><strong>联系方式</strong></p><p></p><p>如有任何疑问，欢迎随时致电我们<br>电话: 017-2043340<br>电邮: <a target="_blank" rel="noopener noreferrer nofollow" href="mailto:zhushan.mychan@gmail.com">zhushan.mychan@gmail.com</a></p><p></p><p>让我们携手共建竺山禅院，为后世留下一个传承禅法的道场，为这片土地种下心灵和平的种子。感恩您的发心护持，祝愿您吉祥安康，福慧绵长。</p><p></p><p><strong>竺山禅院感恩您的随喜支持！</strong></p>`,
  contentCNSimp: `<p><strong>竺山青少年禅意营</strong></p><p></p><p>马来西亚竺山禅院以弘扬汉传禅法及禅文化为使命，致力于打造一个融教育与实践于一体的禅修中心。这片灵气山地，将为无数身心疲惫的现代人提供安顿之所，更为禅文化的传承与推广奠定基础。</p><p></p><p>禅院预计于2028年内建成，然而初期建设所需经费庞大，必须仰赖社会大众的共同护持方能圆满完成。您的发心捐献，将成为禅院建成的基石，也将为未来禅修学员的身心成长点燃希望的灯。</p><p></p><p>每一份随喜捐助，都是对禅文化发展的巨大支持；每一份善心护持，都是为社会注入平和宁静的力量。您的点滴善意，将汇聚成禅院建设的坚实后盾，让这片土地上的人们得以因禅法受益，改善生命品质。</p><p></p><p><strong>如何护持</strong></p><p></p><p>请填写您愿意护持的金额，无论多少，皆是不可或缺的一份力量。</p><p></p><p><strong>联系方式</strong></p><p></p><p>如有任何疑问，欢迎随时致电我们<br>电话: 017-2043340<br>电邮: <a target="_blank" rel="noopener noreferrer nofollow" href="mailto:zhushan.mychan@gmail.com">zhushan.mychan@gmail.com</a></p><p></p><p>让我们携手共建竺山禅院，为后世留下一个传承禅法的道场，为这片土地种下心灵和平的种子。感恩您的发心护持，祝愿您吉祥安康，福慧绵长。</p><p></p><p><strong>竺山禅院感恩您的随喜支持！</strong></p>`,
  contentCNTrad: `<p><strong>竺山青少年禅意营</strong></p><p></p><p>马来西亚竺山禅院以弘扬汉传禅法及禅文化为使命，致力于打造一个融教育与实践于一体的禅修中心。这片灵气山地，将为无数身心疲惫的现代人提供安顿之所，更为禅文化的传承与推广奠定基础。</p><p></p><p>禅院预计于2028年内建成，然而初期建设所需经费庞大，必须仰赖社会大众的共同护持方能圆满完成。您的发心捐献，将成为禅院建成的基石，也将为未来禅修学员的身心成长点燃希望的灯。</p><p></p><p>每一份随喜捐助，都是对禅文化发展的巨大支持；每一份善心护持，都是为社会注入平和宁静的力量。您的点滴善意，将汇聚成禅院建设的坚实后盾，让这片土地上的人们得以因禅法受益，改善生命品质。</p><p></p><p><strong>如何护持</strong></p><p></p><p>请填写您愿意护持的金额，无论多少，皆是不可或缺的一份力量。</p><p></p><p><strong>联系方式</strong></p><p></p><p>如有任何疑问，欢迎随时致电我们<br>电话: 017-2043340<br>电邮: <a target="_blank" rel="noopener noreferrer nofollow" href="mailto:zhushan.mychan@gmail.com">zhushan.mychan@gmail.com</a></p><p></p><p>让我们携手共建竺山禅院，为后世留下一个传承禅法的道场，为这片土地种下心灵和平的种子。感恩您的发心护持，祝愿您吉祥安康，福慧绵长。</p><p></p><p><strong>竺山禅院感恩您的随喜支持！</strong></p>`,

}


export default function SupportUs() {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const [selectedFund, setSelectedFund] = useState(null)

  const { isFetching, error, data, isError } = useQuery({
    queryKey: ['getFundContent'],
    queryFn: () =>
      axios.get(UserApiEndpoints.getFundContent, { requiresAuth: false }),
    initialData: [],
    select: (res) => {
      const data = res?.data || []
      // setSelectedFund(data.length > 0 ? data[0] : null)
      return data
    },
  })

  useEffect(()=>{
    if(data.length > 0){
      setSelectedFund(data[0])
    }
  },[data])

  const sanitizedContent = DOMPurify.sanitize(selectedFund ? selectedFund?.[`content${t('param')}`] : ``, {
    ADD_TAGS: ["iframe"], // Add iframe to the list of allowed tags
    ADD_ATTR: ["src", "width", "height", "allowfullscreen", "frameborder"] // Specify allowed attributes
  });

  const isSkeleton = !(data[0]);
  
  return (
    <Container className='support-us'>
      <Typography className='category'>{t('support-page.donate')}</Typography>
      <Typography className='title'>{t('support-page.supportZhuShan')}</Typography>
      <Grid2 container spacing={'25px'}>
        <Grid2 size={{ lg: 3, md: 4,  sm: 12, xs: 12 }}>
          {isSkeleton ?
          <Skeleton animation={!isError && 'pulse'} variant="rounded" height={"400px"} style={{borderRadius: '10px'}}/>
          :
          <Paper className='link-card'>
            <div className='downdown-selection'>
              <CustomAutocomplete 
                options={data}
                value={selectedFund}
                onChange={setSelectedFund}
                laoding={isFetching}
                getOptionLabel={(option) => option[`title${t('param')}`]}
                getOptionKey={(option) => option.fundGuid}
                isOptionEqualToValue={(option, value) => option.fundGuid === value?.fundGuid}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "10px", // Change this to your desired radius
                    "& fieldset": {
                      borderColor: "transparent", // Default border color
                    },
                    "&:hover fieldset": {
                      borderColor: "transparent", // Border color on hover
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "transparent", // Border color when focused
                    },
                  },
                }}
                disableClearable
              />
            </div>
            <div className='menu-selection'>
            {data.map((item, index) => (
              <React.Fragment key={index}>
                <Box className={`fund-card`} onClick={()=>setSelectedFund(item)}>
                  <Typography className='card-title'>{item[`title${t('param')}`]}</Typography>
                  {
                    selectedFund?.fundGuid === item?.fundGuid &&
                    <IconChevronRight size={18}/>
                  }
                  
                </Box>
                {
                  data.length > index + 1 &&
                  <Divider />
                }   
              </React.Fragment>
            ))
            }
            </div>
          </Paper>
          }
        </Grid2>
        <Grid2 size={{ lg: 9, md: 8,  sm: 12, xs: 12 }}>
          {isSkeleton ?
          <Skeleton animation={!isError && 'pulse'} variant="rounded" height={"400px"} style={{borderRadius: '10px'}}/>
          :
          <Paper className='content-card'>
            <Typography className='fund-title'>{selectedFund && selectedFund[`title${t('param')}`]}</Typography>
            <div
              dangerouslySetInnerHTML={{ __html: sanitizedContent }}
              className="rich-text-content"
            />
            <Typography className='description'>{t('support-page.donateInstruction')}</Typography>
            <CustomButton component={RouterLink} to={`/payment?type=donation`}>{t('support-page.donate')}</CustomButton>
          </Paper>
          }
        </Grid2>
      </Grid2>
    </Container>
  )
}
